module.exports = __webpack_public_path__ + "media/images/motto-bg3-31c8d78c6f88ab6d072786b01d037aac.png";